module.exports = __webpack_public_path__ + "img/chsb.c3f45219.svg";